import {
  createFileRoute,
  lazyRouteComponent,
  redirect,
} from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/my-styles/(pages)/(list)/skus')(
  {
    beforeLoad: ({ location }) => {
      if (
        location.pathname === '/my-styles/skus' ||
        location.pathname === '/my-styles/skus/'
      ) {
        throw redirect({ to: '/my-styles/skus/active' });
      }
    },
    component: lazyRouteComponent(
      () => import('../../../-components/SkusLayout'),
      'SkusLayout',
    ),
  },
);
